import {SessionMessage} from '@services/session/session.interface';

export class BroadcastChannelService {
    private channel: BroadcastChannel;
    private debug = false;

    constructor(private channelName: string = 'app-channel') {
        this.channel = new BroadcastChannel(channelName);
    }

    broadcast(message: SessionMessage): void {
        if (this.debug) {
            console.log('[EFE-BroadcastChannelService] Broadcasting: ', message);
        }

        this.channel.postMessage(message);
    }

    close(): void {
        if (this.debug) {
            console.log('[EFE-BroadcastChannelService] Closing channel');
        }

        this.channel.close();
    }

    init(channelName: string): BroadcastChannelService {
        if (this.channel) {
            this.channel.close();
        }

        this.channel = new BroadcastChannel(channelName);

        if (this.debug) {
            console.log(`[BroadcastChannelService] Channel re-initialized with name: ${channelName}`);
        }

        return this;
    }

    listen(onMessageReceived: (message: SessionMessage) => void): void {
        this.channel.onmessage = (event) => {
            const sessionMessage: SessionMessage = event.data;

            if (this.debug) {
                console.log('[EFE-BroadcastChannelService] Message received:', sessionMessage);
            }

            onMessageReceived(sessionMessage);
        };
    }
}
